// src/pages/NotFound.js
import React from 'react';
import Layout from '../components/Layout';
import classes from '../styles/NotFound.module.scss'
import {useEffect,useState} from 'react'

const NotFound = () => {

    useEffect(() => {
        document.title = "Not Found - Velocity Prime"    
    })

  return (
    <Layout>
        <div className={classes.wrapper}>
            <h1>404 Not Found</h1>
            <p>Page Not Found</p>
            {/* Optional: Add a link back to the homepage */}
            <a href="/">Go to Home</a>
        </div>
      
    </Layout>
  );
};

export default NotFound;
